import { captureError, SENTRY_SEVERITY, toApiError } from 'src/service/utils/sentry'
import { JoinTermsDetail, MvnoTermsDetail, TermsResponse } from 'src/types/type'

const TELECOM_KEYS = ['SKTTerms', 'KTTerms', 'LGUPTerms'] as const

type MissingField = 'Title' | 'Contents'

function captureMissingTerm(
  message: string,
  tags: { telecom: string; termKey: string; missing: MissingField },
) {
  captureError(toApiError(new Error(message)), {
    level: SENTRY_SEVERITY.Error,
    tags,
    fingerprint: ['terms-missing', tags.telecom, tags.termKey, tags.missing],
  })
}

export function validateTermItem(telecom: string, termKey: string, term: { Title?: string; Contents?: string }) {
  const title = term.Title?.trim()
  const contents = term.Contents?.trim()

  if (!title) return
  if (!contents) {
    captureMissingTerm(`[${telecom} : ${title}] Contents 누락`, {
      telecom,
      termKey,
      missing: 'Contents',
    })
  }
}

/** 가입 약관 검증 */
export function captureTermsError(response: TermsResponse | undefined) {
  if (!response) return

  TELECOM_KEYS.forEach((telecom) => {
    const terms = response[telecom]
    if (!terms || typeof terms !== 'object') return

    terms.Terms?.forEach((term: JoinTermsDetail, index: number) => {
      if (typeof term !== 'object' || term === null) return
      if (!('Required' in term) && !('Title' in term)) return

      validateTermItem(telecom, String(term.Order ?? index), term)
    })
  })
}

/** MVNO 약관 검증 */
export function captureMvnoTermsError(body?: MvnoTermsDetail) {
  if (!body || body.Type !== 1) return

  const title = body.TermsTitle?.trim()
  const contents = body.Terms?.trim()

  if (!title) {
    captureMissingTerm('[KTTerms : MVNO] Title 누락', {
      telecom: 'KTTerms',
      termKey: 'MVNO',
      missing: 'Title',
    })
  }

  if (!contents) {
    captureMissingTerm('[KTTerms : MVNO] Contents 누락', {
      telecom: 'KTTerms',
      termKey: 'MVNO',
      missing: 'Contents',
    })
  }
}
